var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuntrust = function SvgSuntrust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "suntrust_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".suntrust_svg__st1{fill:#002856}")), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C9 40 0 31 0 20S9 0 20 0s20 9 20 20-9 20-20 20z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "suntrust_svg__Calque_5"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "suntrust_svg__st1",
    d: "M28.3 24.1c0 .6-.1 1.6-1.5 1.6-.3 0-.9 0-1.3-.3-.3-.3-.3-.7-.3-1.3V22c0-.2-.1-.3-.4-.3v-.3h1.9v.3c-.3 0-.4.1-.4.3v2.2c0 .5 0 1.1.8 1.1.9 0 .9-.7.9-1.2v-2.2c0-.2 0-.3-.3-.3h-.1v-.3h1.3v.3h-.2c-.3 0-.3.1-.3.3v2.2zM34.8 25.6h-2.1v-.3h.2c.3 0 .4-.1.4-.3v-3.2h-.4c-.2 0-.3.1-.3.2-.1.1-.1.4-.1.6h-.4v-1.1h3.4v1.1h-.3c0-.2 0-.5-.1-.6-.1-.1-.2-.2-.3-.2h-.4V25c0 .2.1.3.4.3h.2l-.2.3zM32 24.5c-.1.7-.6 1.3-1.6 1.3-.6 0-1.2-.2-1.5-.3v-1h.3v.3s.1.2.2.3c.2.2.4.3.9.3.7 0 .9-.3.9-.7 0-.4-.3-.5-1.1-.8-.9-.2-1.3-.5-1.3-1.3 0-.7.5-1.3 1.5-1.3.6 0 .9.1 1.3.3v.9h-.3v-.3c0-.1-.1-.3-.2-.3-.3-.3-.6-.3-.9-.3-.3 0-.8.2-.8.6 0 .3.2.5.9.7.7.2.9.3 1.2.4.5.4.6.7.5 1.2M8.5 24.1c-.1.8-.7 1.5-2.2 1.5-.8 0-1.6-.3-1.9-.5v-1.3h.4v.4c0 .1.1.3.2.4.3.3.6.5 1.3.5.9 0 1.3-.5 1.3-1 0-.6-.4-.8-1.5-1-1-.3-1.7-.6-1.7-1.6 0-.9.7-1.7 2.1-1.7.9 0 1.3.2 1.6.3v1.2h-.3v-.4c0-.2-.2-.3-.3-.4-.3-.1-.7-.2-1.1-.1-.5 0-1 .3-1 .8s.2.7 1.2.9c.9.2 1.3.3 1.6.6.3.5.3.9.3 1.4M12.9 21.8c.3 0 .3.1.3.3v3.1c0 .2 0 .3-.3.3h-.1v.2h1.3v-.3H14c-.3 0-.3-.1-.3-.3v-2.6l1.7 3.1h.9v-3.5c0-.2 0-.3.3-.3h.3v-.5c0-.4 0-.9.6-.9h.6v4.4c0 .3-.1.5-.5.5h-.2v.3H20v-.3h-.2c-.4 0-.5-.1-.5-.5v-4.4h.6c.6 0 .6.4.6.9v.4h.4c.3 0 .3.1.3.3v3c0 .2-.2.3-.4.3v.3h1.9v-.3c-.3 0-.4-.1-.4-.3v-3.3h.5c.4 0 .7.2.7.8 0 .3-.2.8-.7.8h-.3s.8 1.5.9 1.8c.2.3.4.4.9.4h.8v-.3c-.1 0-.3 0-.4-.2l-.9-1.5c.5-.1.9-.5.9-1 0-1-1-1-1.6-1h-1.9V20h-4.5v1.5h-1v.3h.1c.3 0 .3.1.3.3v2.6l-1.7-3.1h-2.7v.3h.1c.3 0 .3.1.3.3v2.2c0 .5-.1 1.2-.9 1.2s-.8-.6-.8-1.1v-2.2c0-.2.1-.3.4-.3v-.3H8.7v.3c.3 0 .4.1.4.3v2.1c0 .6.1.9.3 1.2.3.3 1 .3 1.3.3 1.5 0 1.5-.9 1.5-1.8v-2.2c0 .1 0 0 .3 0l.4-.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.069,
    y1: 22.902,
    x2: 15.968,
    y2: 32.316,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m8.4 14.6-.1.3c-.1.2-.1.6 0 .8l.4 2.3c0 .2.1.3.2.3s.1-.2 0-.5l-.3-3.1c-.1-.2-.2-.2-.2-.1",
    style: {
      fill: "url(#suntrust_svg__SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.331,
    y1: 22.656,
    x2: 16.202,
    y2: 32.036,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 17.1v.4c-.1 0-.1-.1-.2-.3L9 15.9c0-.2 0-.6.1-.8s.2-.1.2.1v1.9z",
    style: {
      fill: "url(#suntrust_svg__SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.808,
    y1: 23.077,
    x2: 15.65,
    y2: 32.422,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m9.9 12.4-.2 4c0 .2 0 .4-.1.4 0 0-.1-.1-.1-.3l-.1-3.4c0-.2.1-.4.2-.6l.1-.3c.1.1.2.1.2.2",
    style: {
      fill: "url(#suntrust_svg__SVGID_3_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.311,
    y1: 22.637,
    x2: 16.134,
    y2: 31.96,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 13.3-.3 3.1c0 .3-.1.4-.1.4-.1 0-.1-.2-.1-.3l.1-2.7c.1-.2.3-.5.4-.5 0-.3 0-.2 0 0",
    style: {
      fill: "url(#suntrust_svg__SVGID_4_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.949,
    y1: 22.927,
    x2: 15.755,
    y2: 32.228,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 16.1c-.1 0-.1-.3 0-.3l.4-4.3c0-.2.2-.4.3-.5v-.1c.1-.2.2-.2.2 0l-.7 4.8c-.1.2-.1.4-.2.4",
    style: {
      fill: "url(#suntrust_svg__SVGID_5_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.52,
    y1: 22.436,
    x2: 16.305,
    y2: 31.715,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 11.6c.1-.1.3-.1.3.1l-1 4.3c0 .2-.1.4-.2.3-.1 0-.1-.3 0-.4l.7-3.9s.1-.3.2-.4",
    style: {
      fill: "url(#suntrust_svg__SVGID_6_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.043,
    y1: 21.993,
    x2: 16.774,
    y2: 31.206,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 16c-.1.2-.2.3-.3.3-.1 0 .1-.3.1-.3l2.3-5.7c.1-.2.3-.3.4-.3s0 .4-.1.5c-1.3 3.2-1.7 4.1-2.4 5.5",
    style: {
      fill: "url(#suntrust_svg__SVGID_7_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.295,
    y1: 21.781,
    x2: 16.999,
    y2: 30.963,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.7c.1 0 .2-.1.3-.3l4.3-7.1c.1-.1.1-.3 0-.4-.1-.1-.3.1-.4.3l-4 7.2c-.1.1-.2.3-.2.3",
    style: {
      fill: "url(#suntrust_svg__SVGID_8_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.094,
    y1: 21.105,
    x2: 17.776,
    y2: 30.259,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 16.5c-.1-.1 0-.3.2-.4l4.6-6.6c0-.3.3-.5.5-.4.2.1.2.3 0 .4l-5 6.6c-.1.3-.3.4-.3.4",
    style: {
      fill: "url(#suntrust_svg__SVGID_9_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.039,
    y1: 20.311,
    x2: 18.697,
    y2: 29.437,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m14 15.7-.3.3c-.1-.1.1-.2.2-.3l.2-.2 6.4-7.3c.1-.1.3-.2.3 0l.2.3c.1.1.1.3 0 .4l-7 6.8z",
    style: {
      fill: "url(#suntrust_svg__SVGID_10_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.805,
    y1: 19.664,
    x2: 19.437,
    y2: 28.76,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.9c-.1-.1.1-.2.3-.3l6.8-6.3c.1-.1.3-.1.4 0 .2.2.2.3.2.3 0 .2-.1.3-.2.4l-7.1 5.6c-.2.3-.4.4-.4.3",
    style: {
      fill: "url(#suntrust_svg__SVGID_11_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.934,
    y1: 18.714,
    x2: 20.541,
    y2: 27.779,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m14.9 16.4 7.9-5.7c.2-.1.3-.1.3.1l.2.6c0 .2-.1.3-.3.5l-8 4.7c-.2.1-.4.3-.4.2-.1-.2.1-.3.3-.4",
    style: {
      fill: "url(#suntrust_svg__SVGID_12_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.326,
    y1: 18.394,
    x2: 20.893,
    y2: 27.413,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.1 17.5c0-.1.2-.2.4-.3l7.1-3.5c.2-.1.3-.1.3.1v.8c0 .2-.2.3-.4.4l-7 2.4c-.2.2-.4.2-.4.1",
    style: {
      fill: "url(#suntrust_svg__SVGID_13_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.416,
    y1: 17.483,
    x2: 21.935,
    y2: 26.443,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m22.3 16.9-6.8.9c-.3 0-.4.1-.5 0 0-.1.2-.2.4-.3l7.1-2.2c.3-.1.4 0 .3.2l-.1.8c.1.3-.1.5-.4.6",
    style: {
      fill: "url(#suntrust_svg__SVGID_14_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.554,
    y1: 17.377,
    x2: 22.011,
    y2: 26.264,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 18.5c0-.1.3-.2.6-.2l6-.7c.3 0 .5.1.4.3l-.1.3c-.1.2-.3.3-.6.3h-5.8c-.3.1-.5.1-.5 0",
    style: {
      fill: "url(#suntrust_svg__SVGID_15_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.424,
    y1: 22.514,
    x2: 16.182,
    y2: 31.761,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 9.6s-1.7 5.3-1.8 5.7c-.1.3-.2.6-.3.6-.1 0 0-.2.1-.4l1.6-5.9c.1-.3.3-.4.4-.4.2-.2.1.2 0 .4",
    style: {
      fill: "url(#suntrust_svg__SVGID_16_)"
    }
  })));
};
export default SvgSuntrust;